// src/components/quiz/StreakBadgeWithModal.tsx
import React, { useState } from 'react';
import { X } from 'lucide-react';
import StreakMiniBadge from './StreakMiniBadge';
import StreakCalendar from './StreakCalendar';

const StreakBadgeWithModal = ({ userId }: { userId: string }) => {
    const [isOpen, setIsOpen] = useState(false);

    // モーダル外をクリックしたときにモーダルを閉じる
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            setIsOpen(false);
        }
    };

    return (
        <>
            {/* バッジ（クリックでモーダル開く） */}
            <button onClick={() => setIsOpen(true)} className="focus:outline-none">
                <StreakMiniBadge userId={userId} />
            </button>

            {/* モーダル */}
            {isOpen && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-8"
                    onClick={handleOverlayClick} // オーバーレイをクリックしたときに閉じる
                >
                    <div className="fixed inset-0 bg-black bg-opacity-40" aria-hidden="true" />

                    <div className="relative bg-white rounded-xl p-6 w-full max-w-sm mx-auto shadow-lg z-50">
                        <button
                            onClick={() => setIsOpen(false)}
                            className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                            aria-label="モーダルを閉じる"
                        >
                            <X size={20} />
                        </button>
                        <h2 className="text-lg font-semibold mb-4 text-center">あなたの記録</h2>
                        <StreakCalendar userId={userId} />
                    </div>
                </div>
            )}
        </>
    );
};

export default StreakBadgeWithModal;